/** Renders the cost of an offer */

import React from 'react'
import { Map } from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import numeral from 'numeral'

const AccommodationCost = ({ cost = Map(), children}) =>
    <div className="col-wrapper-va">
        <div className="v-align">
            {children}
            <label className="price">
                {
                  cost.isEmpty() ? null :
                  <span>{cost.get('currency')} <em>{numeral(cost.get('amount')).format('0,0.00')}</em></span>
                }
            </label>
            <a className="btn btn-nx btn-go">SELECT</a>
        </div>
    </div>

AccommodationCost.propTypes = {
    cost: ImmutablePropTypes.map.isRequired,
    // passengerCount: PropTypes.number,
    children: PropTypes.any
}

export default AccommodationCost



// WEBPACK FOOTER //
// ./src/ndc/offer/AccommodationCost.js